import type { ToolModule } from './types'
import { authTokenModule } from '../../modules/auth-token/module'
import { registrationModule } from '../../modules/registration/module'
import { stockModule } from '../../modules/stock/module'
import { stockTransferModule } from '../../modules/stock-transfer/module'
import { summaryModule } from '../../modules/summary/module'

// The single registry of modules. Order = nav order.
// Future modules slot in here: paymentsModule, prospectsModule, …
export const MODULES: ToolModule[] = [
  authTokenModule,
  registrationModule,
  stockModule,
  stockTransferModule,
  summaryModule,
]
